import {DateTime} from "luxon";
import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {KnowledgeObjectDTO} from "../domain/dtos/knowledge-object.dto";
import {KnowledgeObject} from "../domain/entities/knowledge-object.entity";
import {AbstractDtoToEntityTransformer} from "./abstract-dto-to-entity.transformer";

@injectable()
@transformer({
    source: `dto`,
    target: KnowledgeObject
})
export class DtoToKnowledgeObjectTransformer extends AbstractDtoToEntityTransformer<KnowledgeObjectDTO, KnowledgeObject> {

    /**
     * Maps a KnowledgeObjectDTO to a KnowledgeObject entity.
     * Date strings are parsed to Luxon DateTime; `uid` and `createdAt`
     * are assigned by the base transformer.
     */
    protected toEntity(dto: KnowledgeObjectDTO): Promise<KnowledgeObject> {

        const entity = Object.assign(new KnowledgeObject(), {
            type: dto.type,
            title: dto.title,
            payloadVersion: dto.payloadVersion,
            version: dto.version,
            creatorUid: dto.creatorUid,
            lastEditorUid: dto.lastEditorUid,
            updatedAt: DateTime.fromSQL(dto.updatedAt),
            deletedAt: !!dto.deletedAt ? DateTime.fromSQL(dto.deletedAt) : null,
            lockedAt: dto.lockedAt ?? null,
            lockedBy: dto.lockedBy ?? null,
        });

        // Optional content (PRD-076): present only when the backend query was
        // sent with includes:['content']. Drop the redundant knowledgeObjectUid —
        // entity.uid is authoritative.
        if (dto.content) {
            entity.content = {payload: dto.content.payload};
        }

        return Promise.resolve(entity);
    }

}
